import { useMemo } from 'react'

import { CommonProps, LockoutActionsTypes } from './types'
import { modalsActions } from './utils'

type Props = {
  type: LockoutActionsTypes
} & CommonProps

export const LockoutActions = ({ type, data, ...props }: Props) => {
  const Component = useMemo(() => modalsActions[type], [type])

  if (!Component) return null

  return <Component data={data} {...props} />
}
